<template>
    <!--Widget Settings Main Subpage-->
    <div class="widget-settings-main-container">

        <!--Widget Settings subpage-->
        <div v-if="user && user.role == 'stylist'" class="widget-settings-container">

            <div class="widget-settings-heading">
                <h3>{{ $t("adminMenu.widgetSettings") }}</h3>
            </div>

            <div v-if="bookNowWidgetSettingActive && !loadingBookingWidgetData"
                class="widget-settings-content section-wrap highlighted-box">

                <div class="widget-wrap">

                    <!-- LEFT SIDE -->
                    <div class="widget-left-side section-wrap">

                        <!-- Button Label -->
                        <div class="widget-field">
                            <span>Button Label:</span>
                            <input type="text" class="text-field text-field-small" v-model="buttonLabel" />
                        </div>

                        <!-- Border Radius -->
                        <div class="widget-field">
                            <span>Button Border Radius:</span>
                            <input type="number" class="text-field text-field-small" v-model="buttonBorderRadius" />
                        </div>

                        <!-- Dynamic Color Pickers -->
                        <div v-for="field in colorFields" :key="field.key" class="widget-field color-picker-container">

                            <span>{{ field.label }}</span>

                            <div class="widget-color-icon" :style="{ backgroundColor: this[field.key] }"
                                @click="toggleColorPicker(field.key)">
                            </div>

                            <div v-if="activeColorPicker === field.key" class="color-picker"
                                :style="{ background: this[field.key] }">

                                <color-picker v-model:pureColor="this[field.key]"
                                    @changeColor="(color) => updateColor(field.key, color)" :isWidget="true"
                                    :presetColors="presetColors" />

                                <div class="d-flex">
                                    <button type="button" class="btn btn-light d-block m-auto"
                                        @click="activeColorPicker = null">
                                        OK
                                    </button>
                                </div>

                            </div>
                        </div>

                    </div>

                    <!-- RIGHT SIDE -->
                    <div class="widget-right-side section-wrap">

                        <button :style="buttonStyles">
                            {{ buttonLabel }}
                        </button>

                        <div class="demo-modal-wrap">
                            <div class="demo-modal-heading">Model</div>

                            <div class="demo-model-header" :style="modelHeaderStyles">
                                Model Header
                            </div>

                            <div class="demo-model-body" :style="modelBodyStyles">
                                Model Body
                            </div>
                        </div>

                    </div>

                </div>

                <div class="save-widget-btn">
                    <button type="button" class="primary-btn extra-small" @click="saveWidgetChoices">
                        {{ $t("general.save") }}
                    </button>
                </div>

            </div>
            <MainLoader v-if="loadingBookingWidgetData" class="section-wrap" />
        </div>

        <!-- Widget Snippet -->
        <div v-if="bookNowWidgetSettingActive &&
            idHash &&
            user &&
            user.role == 'stylist' && !loadingBookingWidgetData"
            class="widget-snippet-container section-wrap highlighted-box">

            <div class="widget-snippet-heading">
                <h4>{{ $t("adminMenu.widgetSnippet") }}</h4>
            </div>

            <div class="widget-textarea-wrap">
                <textarea class="widget-textarea" rows="2" disabled :value="widgetTextArea1 + widgetTextArea2">
                </textarea>
            </div>

            <div class="copy-widget-btn">
                <button type="button" class="primary-btn extra-small" @click="copyToClipboard">
                    Copy
                </button>
            </div>
        </div>

        <!-- Profile Widget Settings -->
        <div v-if="user && user.role == 'stylist' && !loadingBookingWidgetData" class="section-wrap highlighted-box">

            <div>
                <h4>{{ $t("adminMenu.profileWidgetSettings") }}</h4>
            </div>

            <div class="members-wrapper section-wrap">
                <div class="members-list">

                    <div class="member-header">
                        <div>{{ $t("general.name") }}</div>
                        <div>{{ $t("general.active") }}</div>
                    </div>

                    <div class="member" v-for="(settings, id) in profileWidgetSettings" :key="id">

                        <div class="member-row-cell">
                            {{ settings.name }}
                        </div>

                        <div class="input-btns-wrap">

                            <label class="switch">
                                <input type="checkbox" v-model="settings.active"
                                    @change="displayProfileWidgetSaveButton = true" class="member-active" />
                                <span class="slider round"></span>
                            </label>

                            <span v-if="settings.id_hash && settings.active" class="widget-snippet-button-wrap">

                                <button type="button" class="primary-btn extra-small"
                                    @click="copyWidgetCodeToClipboard(getProfileWidgetSnippet(settings.id_hash))">
                                    Copy Snippet
                                </button>

                            </span>

                        </div>
                    </div>
                </div>
            </div>

            <div v-if="displayProfileWidgetSaveButton" class="save-widget-btn">
                <button type="button" class="primary-btn extra-small" @click="saveProfileWidgetSettings">
                    {{ $t("general.save") }}
                </button>
            </div>
        </div>

    </div>
</template>

<script>
import auth from '../../services/auth';
import api from '../../services/apiEndpoints';
import messages from '../../services/messages';
import { ColorPicker } from "vue3-colorpicker";
import 'vue3-colorpicker/style.css';

import MainLoader from "./general-components/MainLoader.vue"

export default {

    name: "BookingWidget",

    components: { ColorPicker },

    data() {
        return {
            user: null,

            activeColorPicker: null,

            presetColors: [
                '#000000',
                '#FFFFFF',
                '#FF1900',
                '#FFE623',
                '#6EFF2A',
                '#2E81FF',
                '#FF89CF',
            ],

            colorFields: [
                { label: "Button Color", key: "buttonColor" },
                { label: "Button Text Color", key: "buttonTextColor" },
                { label: "Button Border Color", key: "buttonBorderColor" },
                { label: "Model Background Color", key: "modelBackgroundColor" },
                { label: "Model Text Color", key: "modelTextColor" },
                { label: "Model Header Background Color", key: "modelHeaderBackgroundColor" },
                { label: "Model Header Text Color", key: "modelHeaderTextColor" },
            ],

            bookNowWidgetSettingActive: false,
            profileWidgetSettings: {},
            displayProfileWidgetSaveButton: false,

            bookNowWidgetSetting: {},

            buttonLabel: "",
            buttonColor: "",
            buttonTextColor: "",
            buttonBorderColor: "",
            modelBackgroundColor: "",
            modelTextColor: "",
            modelHeaderBackgroundColor: "",
            modelHeaderTextColor: "",
            buttonBorderRadius: "",

            widgetTextArea1: "",
            widgetTextArea2: "",
            idHash: null,
            idHasBeenInserted: false,
            loadingBookingWidgetData: false,
        };
    },

    computed: {

        buttonStyles() {
            return {
                borderRadius: this.buttonBorderRadius + 'px',
                backgroundColor: this.buttonColor,
                color: this.buttonTextColor,
                border: '1px solid ' + this.buttonBorderColor,
            };
        },

        modelHeaderStyles() {
            return {
                backgroundColor: this.modelHeaderBackgroundColor,
                color: this.modelHeaderTextColor,
            };
        },

        modelBodyStyles() {
            return {
                backgroundColor: this.modelBackgroundColor,
                color: this.modelTextColor,
            };
        }

    },

    mounted() {

        this.user = auth.state.user;

        let widgetUrl = import.meta.env.VITE_WIDGET_RMS_ENDPOINT;
        if (this.generalOptions.app_id == 2) {
            widgetUrl = import.meta.env.VITE_WIDGET_RMB_ENDPOINT;
        }

        let scriptTag = 'script';
        this.widgetTextArea1 =
            '<link href="' + widgetUrl + 'css/app.css" rel="stylesheet"><vue-widget';

        this.widgetTextArea2 =
            '></vue-widget><script src="' + widgetUrl + 'js/app.js">' +
            `</${scriptTag}>`;

        if (this.user.role == "stylist") {
            this.getWidgetChoices();
            this.getProfileWidgetSettings();
        }
    },

    methods: {
        toggleColorPicker(key) {
            this.activeColorPicker =
                this.activeColorPicker === key ? null : key;
        },

        updateColor(property, color) {
            const { r, g, b, a } = color.rgba;
            this[property] = `rgba(${r}, ${g}, ${b}, ${a})`;
        },

        saveProfileWidgetSettings() {
            var settings = {};

            for (let i in this.profileWidgetSettings) {
                settings[i] = {
                    active: Boolean(
                        this.profileWidgetSettings[i].active == true ||
                        this.profileWidgetSettings[i].active == 1 ||
                        this.profileWidgetSettings[i].active === "1"
                    )
                };
            }

            this.$http.post(api.actions.save_profile_widget_settings, { settings })
                .then(() => {
                    this.getProfileWidgetSettings();
                    messages.successMessage(messages.GLOBAL_MESSAGES.WIDGET_SETTINGS_SAVED);
                });
        },

        copyWidgetCodeToClipboard(code) {
            const el = document.createElement("textarea");
            el.value = code;
            document.body.appendChild(el);
            el.select();
            document.execCommand("copy");
            document.body.removeChild(el);
            messages.successMessage(messages.GLOBAL_MESSAGES.WIDGET_SNIPPET_COPIED);
        },

        copyToClipboard() {
            const el = document.createElement("textarea");
            el.value = this.widgetTextArea1 + this.widgetTextArea2;
            document.body.appendChild(el);
            el.select();
            document.execCommand("copy");
            document.body.removeChild(el);
            messages.successMessage(messages.GLOBAL_MESSAGES.WIDGET_SNIPPET_COPIED);
        },

        getProfileWidgetSettings() {
            this.loadingBookingWidgetData = true;

            this.$http.get(api.actions.get_profile_widget_settings)
                .then((response) => {
                    if (response.data) {
                        let normalized = {};
                        Object.keys(response.data).forEach(key => {
                            normalized[key] = {
                                ...response.data[key],
                                active: !!Number(response.data[key].active)
                            };
                        });
                        this.profileWidgetSettings = normalized;
                    }
                })
                .finally(() => {
                    this.loadingBookingWidgetData = false;
                });
        },

        saveWidgetChoices() {

            let data = {
                button_label: this.buttonLabel,
                button_color: this.buttonColor,
                button_text_color: this.buttonTextColor,
                button_border_color: this.buttonBorderColor,
                model_background_color: this.modelBackgroundColor,
                model_text_color: this.modelTextColor,
                model_header_background_color: this.modelHeaderBackgroundColor,
                model_header_text_color: this.modelHeaderTextColor,
                button_border_radius: this.buttonBorderRadius,
                active: this.bookNowWidgetSettingActive,
            };

            this.$http.post(api.actions.save_book_now_settings, data)
                .then((response) => {
                    this.getWidgetChoices();
                    messages.successMessage(
                        response?.data?.message ||
                        messages.GLOBAL_MESSAGES.WIDGET_SETTINGS_SAVED
                    );
                });
        },

        resetBookNowWidgetSetting() {
            Object.assign(this, this.bookNowWidgetSetting);
        },

        getWidgetChoices() {

            this.$http.get(api.actions.get_book_now_settings)
                .then((response) => {

                    if (response.data.bookNowWidgetSetting) {

                        this.bookNowWidgetSetting = {
                            buttonLabel: response.data.bookNowWidgetSetting.button_label,
                            buttonColor: response.data.bookNowWidgetSetting.button_color,
                            buttonTextColor: response.data.bookNowWidgetSetting.button_text_color,
                            buttonBorderColor: response.data.bookNowWidgetSetting.button_border_color,
                            modelBackgroundColor: response.data.bookNowWidgetSetting.model_background_color,
                            modelTextColor: response.data.bookNowWidgetSetting.model_text_color,
                            modelHeaderBackgroundColor: response.data.bookNowWidgetSetting.model_header_background_color,
                            modelHeaderTextColor: response.data.bookNowWidgetSetting.model_header_text_color,
                            buttonBorderRadius: response.data.bookNowWidgetSetting.button_border_radius,
                            bookNowWidgetSettingActive: response.data.bookNowWidgetSetting.active,
                        };

                        this.resetBookNowWidgetSetting();

                        if (response.data.bookNowWidgetSetting.id_hash &&
                            !this.idHasBeenInserted) {

                            this.idHash = response.data.bookNowWidgetSetting.id_hash;
                            this.widgetTextArea2 =
                                ' id="' + this.idHash + '" ' + this.widgetTextArea2;

                            this.idHasBeenInserted = true;
                        }
                    }
                });
        },

        getTheWidget() {
            this.bookNowWidgetSettingActive =
                !this.bookNowWidgetSettingActive;
        },

        getProfileWidgetSnippet(id_hash) {

            let widgetUrl = import.meta.env.VITE_WIDGET_PROFILE_RMS_ENDPOINT;
            if (this.generalOptions.app_id == 2) {
                widgetUrl = import.meta.env.VITE_WIDGET_PROFILE_RMB_ENDPOINT;
            }

            let scriptTag = 'script';

            return '<link href="' + widgetUrl +
                'css/app.css" rel="stylesheet"><profile-widget id="' +
                id_hash +
                '" ></profile-widget><script src="' +
                widgetUrl +
                `js/app.js"></${scriptTag}>`;
        }

    },
    components: {
        MainLoader,
        ColorPicker,
    },
};
</script>